module.exports = __webpack_public_path__ + "img/great-britain.671c58db.png";